import React from 'react';
import { useRouterStore } from 'apps/hooks';
import { ProductQuoteApp } from 'apps/productQuote/app';
import { ProductQuoteAppManager } from 'apps/productQuote/productQuoteAppManager';
import { graphqlIdToDgraphId } from 'utils/dgraphId';
import { ShipmentQuoteNavigate } from 'apps/shipmentQuote/utils';
import { Box, Button } from 'components';

export const RowActionButtons = ({
  appManager,
  node: productQuote,
}: {
  appManager: ProductQuoteAppManager;
  node: ProductQuoteApp;
}) => {
  const routerStore = useRouterStore();
  const handleButtonClick = () => {
    // @ts-ignore
    const customerSlug = productQuote.from.customerSpace.path;
    // @ts-ignore
    const dgraphId = graphqlIdToDgraphId(productQuote.id).slice(2);

    ShipmentQuoteNavigate(routerStore, {
      customerSlug,
      pqids: [dgraphId],
    });
  };

  const handleDeleteButton = () => {
    appManager.DeleteProductQuote(productQuote);
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Button
        size='small'
        outline
        icon='delete'
        variant='destructive'
        margin='0 8px 0 0'
        onClick={handleDeleteButton}
      />
      <Button
        size='small'
        outline
        icon='arrow_right'
        iconPosition='right'
        text='Quote from PQ'
        onClick={handleButtonClick}
      />
    </Box>
  );
};
